import ConvictionInfo from "@classes/conviction-info";
import AccidentInfo from "@classes/accident-info";
import {getRandomFutureDate} from "@utils/random-funture-date";

export const VanInsuranceQuoteTestData = {
   /**
    * Step 0 data (Discovery/Contact)
    */
   
   discoveryType: 'Existing Customer',
   referrersName: 'ACME Insurance Brokerage',
   contactOptions: ['Email', 'Phone'], // Array of contact preferences
   discountCode: 'QUOTE50',
   
   contactEmail: 'elara.vance@testquote.co.uk',
   contactPhone: '07700 800910',
   
   /**
    * Step 1 : Data (Personal/Employment)
    */
   
   title: 'Ms.',
   firstName: 'Elara',
   lastName: 'Vance',
   birthDate: '1995-03-22',
   
   houseNumber: '14A',
   addressLine1: 'The High Street',
   addressLine2: 'Apt 3',
   postCode: 'BN1 1AA', // Brighton postcode
   
   maritalStatus: 'Single', // e.g., 'Single', 'Married', 'Divorced', 'Partnered'
   employmentStatus: 'Employed', // e.g., 'Employed Full-Time', 'Self-Employed', 'Student'
   
   isHomeOwner: 'Yes', // e.g., 'Yes', 'No', 'Rent'
   hasChildrenUnder16: 'No',
   
   mainOccupation: 'Software Developer',
   occupationIndustry: 'IT and Technology',
   
   /**
    * Step 2 Data (Driving/Claims History)
    */
   
   drivingLicenseType: 'Full UK Manual', // e.g., 'Full UK', 'Provisional', 'Non-UK'
   provideDrivingLicenseNumber: 'Yes',
   britishDrivingLicenseNumber: 'VANCE950322E90AA',
   drivingLicenseDuration: '2 years', // e.g., 'Less than 1 Year', '2-5 Years', '10+ Years'
   drivingLicenseDate: '2013-06-01',
   dvlaMedicalConditions: 'No',
   additionalDrivingQualifications: 'Pass Plus',
   additionalDrivingQualificationDate: '2013-10-15',
   isBornInUk: 'No',
   lastDateBecameUKResident: '1995-03-22', // Same as birth date if born in UK
   hasNonMotoringCriminalConvictions: 'No',
   otherVehicleUsage: 'Have use of another car', // Indicates they use other vehicles occasionally
   
   // Claims History
   hasAccidentClaimsInLast5Years: 'Yes',
   motorAccidentsList: [
      new AccidentInfo({
         type: 'Accident',
         date: '2023-11-01',
         partyAtFault: 'Both parties', // 'At Fault', 'Not At Fault', 'Not Known'
      }),
      new AccidentInfo({
         type: 'Theft',
         date: '2024-09-14',
         partyAtFault: 'Our Driver', // 'At Fault', 'Not At Fault', 'Not Known'
      }),
   ],
   
   // Convictions History
   hasMotoringConvictionsInLast5Years: 'Yes',
   motorConvictionsList: [
      new ConvictionInfo({
         date: '2024-05-10',
         code: 'SP30', // Speeding conviction
         points: 3,
         fines: 100, // monetary value
         banLengthInMonths : 3,
         wasDriverBreathalysed : 'Yes',
         wasOffenceAccidentRelated : 'No',
      }),
      
      new ConvictionInfo({
         date: '2025-02-25',
         code: 'MS50', // Speeding conviction
         points: 20,
         fines: 250, // monetary value
         banLengthInMonths : 6,
         wasDriverBreathalysed : 'Yes',
         wasOffenceAccidentRelated : 'Yes',
      }),
   ],
   
   /**
    * Step 3: Vehicle info (Car/Usage/Insurance)
    */
   
   isVanRegistrationNumKnown: 'Yes',
   vanRegistrationNumber: 'EF56 XYZ',
   
   vanBodyType: 'VAN', // Leave blank if van
   
   vanMakeAndModel: 'Audi A3',
   vanEstimatedValue: 18000,
   
   // Default state values (if not a van)
   vanSeatNumber: '5',
   vanDoorNumber: '3 Doors',
   anySignOfStickers: 'No',
   vanRoofType: 'Normal Roof',
   vanWheelBase: 'MEDIUM WHEEL BASE',
   
   isVanImported: 'No',
   
   manufacturerName: 'Audi',
   manufacturerModel: 'A3',
   vanRegistrationYear: 2020,
   vanAlarmsOrImmobiliser: 'Factory Fitted',
   vanEngineSize: 1500, // cc
   vanTransmissionType: 'Automatic', // e.g., 'Manual', 'Automatic'
   
   // Modifications
   hasModifications: 'Yes',
   modificationType: 'Performance', // e.g., 'Cosmetic', 'Performance', 'Safety'
   modificationDetails: 'Upgraded turbocharger and custom exhaust.',
   
   vanPurchased: 'Yes', // e.g., 'Outright', 'Financed', 'Leased'
   vanPurchaseDate: '2021-08-01',
   
   registeredKeeper: 'Policyholder', // e.g., 'Proposer', 'Spouse', 'Other'
   legalOwner: 'Spouse/Partner', // e.g., 'Proposer', 'Finance Company', 'Leasing Company'
   vanImpoundedWithPolice: 'No',
   carriageOfDangerousGoods: 'No',
   
   /**
    * Vehicle usage ...
    */
   
   vanParkingAtDay: 'At my home', // e.g., 'Driveway', 'Garage', 'Street Parking'
   vanParkingAtNight: 'Private Garage', // Different location at night
   isVanKeptOnSameAddress: 'No',
   vehicleKeeperAddress: 'BN1 1AA', // Same as home postcode
   
   wasInsuranceDeclinedBefore: 'No',
   insurerName: 'Acme Insurance Co.',
   
   vehicleUsageType: 'Social, Domestic And Pleasure Only', // e.g., 'Social Only', 'Commuting & Social', 'Business'
   estimatedAnnualMileage: 'Up to 10000',
   vanBusinessType: 'Sole Trader', // Leave blank if not a van
   
   // Coverage Details
   insuranceCoverageType: 'Comprehensive', // e.g., 'Third Party Only', 'Fully Comprehensive'
   noClaimsDiscount: '5 years', // Years of NCD
   
   voluntaryExcessAmounts: 'None', // Monetary value
   insurancePaymentType: 'Monthly', // e.g., 'Annually', 'Monthly'
   
   currentOrPreviousInsurerName: 'Zeta Car Insurance',
   renewalPriceOfPreviousInsurer: 850, // monetary value
   insuranceCoverageStartDate: getRandomFutureDate({
      months: 6
   }), // Desired start date
   
   howNCDWasEarned: 'In another country', // e.g., 'Main Policy', 'Named Driver'
   whereNCDWasEarned: 'Yes',
   protectNCDForVehicle: 'Yes',
   
   /**
    * Step 4 (Additional Drivers/Comments)
    */
   
   shouldAddAdditionalDrivers: 'Yes',
   additionalDrivers: [
      {
         title: 'Mrs',
         firstName: 'Ananya',
         lastName: 'Sengupta',
         
         birthDate: '1983-09-14',
         relationship: 'Spouse',
         
         employmentStatus: 'Employed',
         occupation : 'Teacher',
         
         licenseType: 'Full UK-IAM',
         licenseDate: '2014-01-01',
         
         isBornInUK: 'No',
         yearObtainingUKResidency : '2023-09-10',
         
         hasChildren : 'Yes',
         numberOfChildren : 2,
         
         motorAccidentsOrClaimsIn5Years : 'Yes',
         motorAccidentsList : [
            new AccidentInfo({
               type: 'Theft',
               date: '2024-09-14',
               partyAtFault: 'Our Driver',
            })
         ],
         
         motoringConvictionsIn5Years : 'Yes',
         motoringConvictionsList : [
            new ConvictionInfo({
               date: '2024-05-10',
               code: 'SP30',
               points: 3,
               fines: 100,
               banLengthInMonths : 3,
               wasDriverBreathalysed : 'Yes',
               wasOffenceAccidentRelated : 'No',
            })
         ],
      },
   ],
   
   addAdditionalComments: 'I require full breakdown cover included in the policy.',
   termsAgreement: 'Yes',
};